import React, { useState, useEffect } from 'react';
import '../styles/UserInfo.css';

const UserInfo = () => {
  // Exemple d'informations utilisateur initiales (à récupérer depuis votre API ou localStorage)
  const initialData = {
    name: 'Naninan ADE',
    email: 'naninan@africadataentry.com',
    phone: '',
    address: '',
    bio: '',
    title: '',
    accountType: 'cinephile', // Options : 'cinephile', 'presse', 'millieu du cinema'
    favoriteGenre: ''
  };

  const [userInfo, setUserInfo] = useState(initialData);
  const [editMode, setEditMode] = useState(false);

  // Simuler la récupération d'infos utilisateur lors du montage
  useEffect(() => {
    // Par exemple, récupérer depuis localStorage ou via une API
    const storedUser = localStorage.getItem('userInfo');
    if (storedUser) {
      setUserInfo(JSON.parse(storedUser));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Envoyer les modifications vers votre backend ici
    console.log('Informations mises à jour :', userInfo);
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    setEditMode(false);
  };

  return (
    <div className="user-info-page">
      <h1>Mes Informations</h1>
      {editMode ? (
        <form className="user-info-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nom :</label>
            <input type="text" name="name" value={userInfo.name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Email :</label>
            <input type="email" name="email" value={userInfo.email} onChange={handleChange} disabled />
          </div>
          <div className="form-group">
            <label>Téléphone :</label>
            <input type="tel" name="phone" value={userInfo.phone} onChange={handleChange} placeholder="Votre numéro de téléphone" />
          </div>
          <div className="form-group">
            <label>Adresse :</label>
            <input type="text" name="address" value={userInfo.address} onChange={handleChange} placeholder="Votre adresse" />
          </div>
          <div className="form-group">
            <label>Bio :</label>
            <textarea name="bio" value={userInfo.bio} onChange={handleChange} placeholder="Parlez-nous de vous..." rows="3" />
          </div>
          <div className="form-group">
            <label>Titre :</label>
            <input type="text" name="title" value={userInfo.title} onChange={handleChange} placeholder="Votre titre (ex: Cinéphile passionné)" />
          </div>
          <div className="form-group">
            <label>Type de compte :</label>
            <select name="accountType" value={userInfo.accountType} onChange={handleChange}>
              <option value="cinephile">Cinéphile</option>
              <option value="presse">Presse</option>
              <option value="millieu du cinema">Milieu du cinéma</option>
            </select>
          </div>
          <div className="form-group">
            <label>Genre de film préféré :</label>
            <input type="text" name="favoriteGenre" value={userInfo.favoriteGenre} onChange={handleChange} placeholder="Ex: Science-fiction, Drame, Action" />
          </div>
          {/* Pour la photo de profil, vous pouvez ajouter un champ file et gérer l'upload */}
          <div className="form-group">
            <label>Photo de profil :</label>
            <input type="file" name="profilePic" accept="image/*" onChange={(e) => {
              // Ici vous pouvez gérer l'upload et obtenir une URL
              // Pour l'exemple, on simule en stockant juste le nom du fichier
              const file = e.target.files[0];
              if (file) {
                setUserInfo(prev => ({ ...prev, picture: URL.createObjectURL(file) }));
              }
            }} />
          </div>
          <button type="submit" className="save-button">Enregistrer</button>
          <button type="button" className="cancel-button" onClick={() => setEditMode(false)}>Annuler</button>
        </form>
      ) : (
        <div className="user-info-display">
          <div className="profile-picture">
            {userInfo.picture ? (
              <img src={userInfo.picture} alt="Profil" />
            ) : (
              <div className="placeholder-pic">{userInfo.name.charAt(0).toUpperCase()}</div>
            )}
          </div>
          <p><strong>Nom :</strong> {userInfo.name}</p>
          <p><strong>Email :</strong> {userInfo.email}</p>
          {userInfo.phone && <p><strong>Téléphone :</strong> {userInfo.phone}</p>}
          {userInfo.address && <p><strong>Adresse :</strong> {userInfo.address}</p>}
          {userInfo.bio && <p><strong>Bio :</strong> {userInfo.bio}</p>}
          {userInfo.title && <p><strong>Titre :</strong> {userInfo.title}</p>}
          <p><strong>Type de compte :</strong> {userInfo.accountType}</p>
          {userInfo.favoriteGenre && <p><strong>Genre préféré :</strong> {userInfo.favoriteGenre}</p>}
          <button className="edit-button" onClick={() => setEditMode(true)}>Modifier mes informations</button>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
